import {Dictionary} from "../types/Types";

type IActivePolls = Dictionary<any>;

export default class PollingManager {

  private static activePolls: IActivePolls = {};

  static createKey(...args: string[]): string {
    return args.join("_");
  }

  static add(key: string, callback: () => void, interval: number): void {
    if (this.activePolls[key]) {
      clearInterval(this.activePolls[key]);
    }

    callback(); // activate the call back right away
    this.activePolls[key] = setInterval(() => {
      callback();
    }, interval);
  }

  static remove(key: string): void {
    clearInterval(this.activePolls[key]);
    delete this.activePolls[key];
  }
}
